import type { ComputedRef, Ref } from 'vue'
import dayjs from 'dayjs'
import type { EventCalendarDayMap } from '~/composables/types/event'

export const useEventBuyBoxDatePickerSession = (
  internalSelectedDate: Ref<string | undefined>,
  mergedCalendarDayMap:
    | ComputedRef<EventCalendarDayMap>
    | Ref<EventCalendarDayMap>,
  fetchMonth: (month: string) => Promise<void>
) => {
  const getFirstAvailableDateWithinDatesRange = (dates: string[]) => {
    return Object.values(mergedCalendarDayMap.value).find(
      (day) =>
        dayjs(day.day).isAfter(dayjs(dates[0]), 'day') &&
        dayjs(day.day).isBefore(
          dayjs(dates[dates.length - 1]).add(1, 'day'),
          'day'
        ) &&
        day.tickets_left > 0
    )
  }

  const updateDateFromSession = async () => {
    if (!process.client) return
    if (!sessionStorage.getItem('filters')) return

    const filtersData = sessionStorage.getItem('filters')
    if (!filtersData) return

    const datesFromSession = JSON.parse(filtersData)

    if (datesFromSession?.dates && datesFromSession.dates.length > 0) {
      const month = dayjs(datesFromSession.dates[0]).format('YYYY-MM')
      await fetchMonth(month)

      const hasFirstDateInAllowedDays = Object.values(
        mergedCalendarDayMap.value
      ).find(
        (day) => day.day === datesFromSession.dates[0] && day.tickets_left > 0
      )

      const availableDateWithinDatesRange =
        getFirstAvailableDateWithinDatesRange(datesFromSession.dates)

      if (hasFirstDateInAllowedDays) {
        internalSelectedDate.value = datesFromSession.dates[0]
      } else if (availableDateWithinDatesRange) {
        internalSelectedDate.value = availableDateWithinDatesRange.day
      } else {
        return
      }

      delete datesFromSession.dates
      sessionStorage.setItem('filters', JSON.stringify(datesFromSession))
    }
  }

  return {
    getFirstAvailableDateWithinDatesRange,
    updateDateFromSession,
  }
}
